import React, { useState } from 'react';
import emailjs from 'emailjs-com';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
    time: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      await emailjs.send(
        'service_zl8ddlx',
        'template_7rt0uyf',
        {
          name: formData.name,
          phone: formData.phone,
          email: formData.email,
          message: formData.message,
          time: formData.time,
        },
        '3bjOm8vL2HsAgnmih'
      );
      setIsSubmitted(true);
      setTimeout(() => {
        setIsSubmitted(false);
        setFormData({
          name: '',
          email: '',
          phone: '',
          message: '',
          time: ''
        });
      }, 3000);
    } catch (err) {
      setError('Failed to send message. Please try again later.');
    }
  };

  return (
    <div className="contact-page">
      <div className="page-header">
        <div className="container">
          <h1 className="page-title">Contact Us</h1>
          <p className="page-subtitle">
            Ready to start your luxury home project? Get in touch with our team to discuss your vision and bring your dream home to life.
          </p>
        </div>
      </div>

      <section className="section">
        <div className="container">
          <div className="grid grid-2">
            {/* Contact Form */}
            <div className="contact-form-section">
              <h2 className="form-title">Start Your Project</h2>
              <p className="form-subtitle">Fill out the form below and we'll get back to you within 24 hours.</p>
              
              {isSubmitted ? (
                <div className="success-message">
                  <div className="success-icon">✓</div>
                  <h3>Thank you for your inquiry!</h3>
                  <p>We've received your message and will contact you within 24 hours to discuss your project.</p>
                </div>
              ) : (
                <form className="contact-form" onSubmit={handleSubmit}>
                  {error && (
                    <div style={{ color: 'red', textAlign: 'center', marginBottom: 12 }}>{error}</div>
                  )}
                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="name" className="form-label">Full Name *</label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        className="form-input"
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="email" className="form-label">Email Address *</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        className="form-input"
                        required
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="phone" className="form-label">Phone Number *</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      className="form-input"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="time" className="form-label">Best Time to Contact *</label>
                    <input
                      type="text"
                      id="time"
                      name="time"
                      value={formData.time}
                      onChange={handleInputChange}
                      className="form-input"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="message" className="form-label">Project Details *</label>
                    <textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleInputChange}
                      className="form-input form-textarea"
                      rows="5"
                      placeholder="Tell us about your project vision, timeline, and any specific requirements..."
                      required
                    />
                  </div>

                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <button type="submit" className="btn btn-primary submit-btn">
                      Send Message
                    </button>
                  </div>
                </form>
              )}
            </div>

            {/* Contact Information */}
            <div className="contact-info-section">
              <h2 className="info-title">Get In Touch</h2>
              
              <div className="contact-methods">
                <div className="contact-method">
                  <div className="method-icon">📞</div>
                  <div className="method-content">
                    <h4>Phone</h4>
                    <p>678-373-7464</p>
                  </div>
                </div>

                <div className="contact-method">
                  <div className="method-icon">✉️</div>
                  <div className="method-content">
                    <h4>Email</h4>
                    <p>admin@osleyandassociates.com</p>
                  </div>
                </div>

                <div className="contact-method">
                  <div className="method-icon">🕒</div>
                  <div className="method-content">
                    <h4>Business Hours</h4>
                    <p>Monday - Friday: 8:00 AM - 6:00 PM<br />Saturday: Closed<br />Sunday: Closed</p>
                  </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', margin: '24px 0' }}>
                  <a href="https://instagram.com/osleyandassociates" target="_blank" rel="noopener noreferrer" style={{
                    display: 'inline-block',
                    background: 'linear-gradient(135deg, #0a0f1a 0%, #1a2332 100%)',
                    color: '#fff',
                    border: '2px solid #b8956d',
                    borderRadius: '10px',
                    padding: '14px 32px',
                    fontWeight: 600,
                    fontSize: '1.1rem',
                    textDecoration: 'none',
                    boxShadow: '0 4px 20px rgba(10,15,26,0.12)',
                    letterSpacing: '0.5px',
                    transition: 'background 0.3s, color 0.3s',
                  }}>
                    Follow us on Instagram
                  </a>
                </div>
              </div>

              <div className="consultation-info">
                <h3>Free Consultation</h3>
                <p>Schedule a complimentary consultation to discuss your project ideas and explore how we can bring your vision to life.</p>
                <div className="consultation-features">
                  <div className="feature">Project assessment</div>
                  <div className="feature">Design possibilities</div>
                  <div className="feature">Budget planning</div>
                  <div className="feature">Timeline discussion</div>
                </div>
                <div style={{ marginTop: '20px' }}>
                  <a href="https://instagram.com/osleyandassociates" target="_blank" rel="noopener noreferrer" className="social-link">Follow us on Instagram</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <style jsx>{`
        .contact-page {
          padding-top: 80px;
        }

        .page-header {
          background: linear-gradient(135deg, var(--primary-blue) 0%, var(--secondary-blue) 100%);
          color: var(--white);
          padding: 80px 0;
          text-align: center;
        }

        .page-title {
          font-size: 3rem;
          margin-bottom: 20px;
          font-family: 'Playfair Display', serif;
        }

        .page-subtitle {
          font-size: 1.25rem;
          color: var(--light-blue);
          max-width: 700px;
          margin: 0 auto;
          line-height: 1.6;
        }

        .contact-form-section {
          background: var(--white);
          padding: 40px;
          border-radius: 12px;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
        }

        .form-title {
          font-size: 2rem;
          color: var(--primary-blue);
          margin-bottom: 10px;
          font-family: 'Playfair Display', serif;
        }

        .form-subtitle {
          color: var(--text-light);
          margin-bottom: 30px;
          line-height: 1.6;
        }

        .contact-form {
          display: flex;
          flex-direction: column;
          gap: 20px;
        }

        .form-row {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 20px;
        }

        .form-group {
          display: flex;
          flex-direction: column;
        }

        .form-label {
          margin-bottom: 8px;
          font-weight: 600;
          color: var(--text-dark);
        }

        .form-input {
          padding: 15px;
          border: 2px solid #e2e8f0;
          border-radius: 8px;
          font-size: 1rem;
          transition: border-color 0.3s ease;
          background: var(--off-white);
        }

        .form-input:focus {
          outline: none;
          border-color: var(--gold-accent);
          box-shadow: 0 0 0 3px rgba(217, 119, 6, 0.1);
        }

        .form-textarea {
          resize: vertical;
          min-height: 120px;
          font-family: inherit;
        }

        .submit-btn {
          align-self: flex-start;
          margin-top: 10px;
        }

        .success-message {
          background: linear-gradient(135deg, #10b981 0%, #059669 100%);
          color: var(--white);
          padding: 40px;
          border-radius: 12px;
          text-align: center;
        }

        .success-icon {
          font-size: 3rem;
          margin-bottom: 20px;
        }

        .success-message h3 {
          font-size: 1.5rem;
          margin-bottom: 15px;
          font-family: 'Playfair Display', serif;
        }

        .contact-info-section {
          background: var(--off-white);
          padding: 40px;
          border-radius: 12px;
        }

        .info-title {
          font-size: 2rem;
          color: var(--primary-blue);
          margin-bottom: 30px;
          font-family: 'Playfair Display', serif;
        }

        .contact-methods {
          margin-bottom: 40px;
        }

        .contact-method {
          display: flex;
          align-items: flex-start;
          gap: 15px;
          margin-bottom: 30px;
        }

        .method-icon {
          font-size: 1.5rem;
          color: var(--gold-accent);
          margin-top: 5px;
        }

        .method-content h4 {
          font-size: 1.125rem;
          color: var(--primary-blue);
          margin-bottom: 5px;
          font-family: 'Playfair Display', serif;
        }

        .method-content p {
          color: var(--text-light);
          line-height: 1.6;
        }

        .consultation-info {
          background: var(--white);
          padding: 30px;
          border-radius: 12px;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
        }

        .consultation-info h3 {
          font-size: 1.5rem;
          color: var(--primary-blue);
          margin-bottom: 15px;
          font-family: 'Playfair Display', serif;
        }

        .consultation-info p {
          color: var(--text-light);
          line-height: 1.6;
          margin-bottom: 20px;
        }

        .consultation-features {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 8px;
        }

        .feature {
          color: var(--text-dark);
          font-size: 0.875rem;
          font-weight: 500;
        }

        .feature::before {
          content: '✓';
          color: var(--gold-accent);
          font-weight: 700;
          margin-right: 8px;
        }

        @media (max-width: 768px) {
          .page-title {
            font-size: 2rem;
          }

          .form-row {
            grid-template-columns: 1fr;
          }

          .consultation-features {
            grid-template-columns: 1fr;
          }

          .contact-form-section,
          .contact-info-section {
            padding: 30px 20px;
          }
        }
      `}</style>
    </div>
  );
};

export default Contact;